'use strict';

import expanderTemplate from './expander.html';


export default function($compile) {
	'ngInject';

	return {
		controller: controller,
		controllerAs: '$expansion',
		link: postLink,
	};

	function postLink(scope, element, attrs) {
		element.append($compile(expanderTemplate)(scope));
		scope.$watch('$expansion.expanded', function(value) {
			if (value) return element.addClass('expanded');
			element.removeClass('expanded');
		});
	}

	function controller() {
		this.expanded = false;
	}
}
